module.exports = __webpack_public_path__ + "static/media/duvet.881a7ef1.png";